import { ShiftHintDatePickerStoreSchema } from "../store";
import { mutatorAction } from "satcheljs";

/**
 * set isCalloutShowing in the shiftHintDatePickerStore that is passed in
 */
export default mutatorAction('SET_IS_CALLOUT_SHOWING_IN_STORE', function setIsCalloutShowingInStore(shiftHintDatePickerStore: ShiftHintDatePickerStoreSchema, isCalloutShowing: boolean) {
    shiftHintDatePickerStore.isCalloutShowing = isCalloutShowing;
});
